import React, { useState } from "react";
import styled from "styled-components";
import FormModal from "../FormModal"; // Adjust path as needed

const CounselingSection = ({ activeTab }) => {
  const [formModalOpen, setFormModalOpen] = useState(false);

  // Content based on activeTab
  const content = {
    student: {
      heading: "FREE Student Counseling!",
      subtext: "Let us help you find the perfect tutor for your needs.",
    },
    tutor: {
      heading: "FREE Tutor Support!",
      subtext: "Get guidance to start teaching and impacting lives.",
    },
  };

  // Default to 'student' if activeTab is not valid
  const currentContent = content[activeTab] || content.student;

  return (
    <StyledSection className="relative py-12 px-6 overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-14 left-20 w-24 h-24 bg-blue-300 opacity-30 rounded-full transform -translate-x-12 -translate-y-12 animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-20 h-20 bg-red-200 opacity-40 rounded-lg rotate-12 hidden md:block"></div>

      {/* Main Content */}
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 animate-fadeIn">
          {currentContent.heading}
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 mb-6 animate-fadeIn animate-delay-200">
          {currentContent.subtext}
        </p>
        <button
          onClick={() => setFormModalOpen(true)}
          className="px-8 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-full shadow-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 transform hover:scale-105"
        >
          Inquiry Now
        </button>
      </div>

      {/* Form Modal */}
      <FormModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        activeTab={activeTab}
      />
    </StyledSection>
  );
};

// Styled-component with custom animations
const StyledSection = styled.section`
  .animate-fadeIn {
    animation: fadeIn 1s ease-out forwards;
  }

  .animate-delay-200 {
    animation-delay: 0.2s;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .animate-spin-slow {
    animation: spin-slow 10s linear infinite;
  }

  @keyframes spin-slow {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export default CounselingSection;